import { render, staticRenderFns } from "./MyCompanyGroupsEdit.vue?vue&type=template&id=3edefc14&"
import script from "./MyCompanyGroupsEdit.vue?vue&type=script&lang=js&"
export * from "./MyCompanyGroupsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports